import * as React from 'react';
import { Popup as RsgPopup } from '@ridi/rsg';

export interface PopupHandle {
  open(): void;
  close(): void;
};

type PopupProps = Omit<React.ComponentProps<typeof RsgPopup>, 'active' | 'onCancel'>;

export const Popup = React.forwardRef<PopupHandle, PopupProps>(({ children, ...props }: PopupProps, ref): JSX.Element => {
  const [ isOpened, setIsOpened ] = React.useState(false);

  const lockContentBase = () => { document.body.style.overflow = 'hidden'; };
  const unlockContentBase = () => { document.body.style.removeProperty('overflow'); };

  const open = () => setIsOpened(true);
  const close = () => setIsOpened(false);

  React.useEffect(() => {
    if (!isOpened) {
      return undefined;
    }

    const onEscapeClose = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        close();
      }
    };

    lockContentBase();
    window.addEventListener('keydown', onEscapeClose);

    return () => {
      unlockContentBase();
      window.removeEventListener('keydown', onEscapeClose);
    };
  }, [ isOpened ]);

  React.useImperativeHandle(ref, () => ({
    open,
    close
  }));

  return (
    <RsgPopup {...props} active={isOpened} onCancel={close}>
      { children }
    </RsgPopup>
  );
});



// WEBPACK FOOTER //
// ./components/popup/Popup.tsx